module.exports = __webpack_public_path__ + "static/wide-coverage-6e52897d50c66901f0529f9b630f63d1.png";